import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ReconciliationFilledSvg from "@ant-design/icons-svg/es/asn/ReconciliationFilled";
import AntdIcon from "../components/AntdIcon";
var ReconciliationFilled = function ReconciliationFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ReconciliationFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ReconciliationFilled.displayName = 'ReconciliationFilled';
}
export default /*#__PURE__*/React.forwardRef(ReconciliationFilled);